<template>
    <div>
        <b-modal
            size="xl"
            v-model="showModal"
            @hidden="$_hideModal()"
            scrollable
            :title="title"
        >
            <b-form ref="controlDataRecordForm" v-if="localControlDataRecord">
                <div class="form-group">
                    <div class="col-md-6">
                        <!--Name-->
                        <x-input
                            id="gemeenteNaam"
                            type="text"
                            :text="this.$t('apiSettings.gemeenteNaam')"
                            v-model="localControlDataRecord.gemeenteNaam"
                            :maxlength="50"
                            :state="gemeenteNaamState"
                            :invalidMessage="gemeenteNaamInvalidMessage"
                            @input="$_validateGemeenteNaam()"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.receiverApplicationName')
                            "
                            v-model="
                                localControlDataRecord.receiverApplicationName
                            "
                            :state="receiverApplicationNameState"
                            :invalidMessage="
                                receiverApplicationNameInvalidMessage
                            "
                            @input="$_validateReceiverApplicationName()"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.receiverOrganizationName')
                            "
                            v-model="
                                localControlDataRecord.receiverOrganizationName
                            "
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t(
                                    'apiSettings.receiverAdministrationName'
                                )
                            "
                            v-model="
                                localControlDataRecord.receiverAdministration
                            "
                        />
                        <x-input
                            type="text"
                            :text="this.$t('apiSettings.senderApplicationName')"
                            v-model="
                                localControlDataRecord.senderApplicationName
                            "
                            :state="senderApplicationNameState"
                            :invalidMessage="
                                senderApplicationNameInvalidMessage
                            "
                            @input="$_validateSenderApplicationName()"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.senderOrganizationName')
                            "
                            v-model="
                                localControlDataRecord.senderOrganizationName
                            "
                            :state="senderOrganizationNameState"
                            :invalidMessage="
                                senderOrganizationNameInvalidMessage
                            "
                            @input="$_validateSenderOrganizationName()"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.senderAdministrationName')
                            "
                            v-model="
                                localControlDataRecord.senderAdministration
                            "
                        />
                    </div>
                    <div class="col-md-12">
                        <dual-listbox
                            :titleAvailable="
                                $t('apiSettings.kadastraleGemeenteAvailable')
                            "
                            :titleSelected="
                                $t('apiSettings.kadastraleGemeenteSelected')
                            "
                            :itemsAvailable="availableGemCodes"
                            :itemsSelected="selectedGemCodes"
                            :items="kadastraleGemeenteCodes"
                            itemDisplayName="text"
                            :showUpDownButtons="false"
                            @update="$_updateKadastraleGemeenteCodes($event)"
                        >
                        </dual-listbox>
                    </div>
                </div>
            </b-form>
            <template #modal-footer>
                <div class="w-100">
                    <b-button variant="primary" @click="$_onSubmit()">
                        {{ $t('btnSaveLabel') }}&nbsp;<span
                            class="fas fa-check"
                        ></span>
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import XInput from '../../components/BaseComponents/x-input.vue';
    import { KADASTRALEGEMEENTECODES } from '../../constants';
    import DualListBox from '../../components/DualListBox.vue';

    export default {
        name: 'data-import-detail-modal',

        mixins: [modalMixin],

        components: {
            'x-input': XInput,
            'dual-listbox': DualListBox
        },

        props: {
            controlDataRecord: { type: Object, required: true },
            controlDataRecords: { type: Array, required: true },
            launchModal: { type: Boolean, required: false, default: false }
        },

        data() {
            return {
                showModal: false,
                localControlDataRecord: null,
                gemeenteNaamState: true,
                gemeenteNaamInvalidMessage: null,
                receiverApplicationNameState: true,
                receiverApplicationNameInvalidMessage: null,
                senderApplicationNameState: true,
                senderApplicationNameInvalidMessage: null,
                senderOrganizationNameState: true,
                senderOrganizationNameInvalidMessage: null,
                kadastraleGemeenteCodes: []
            };
        },

        computed: {
            title() {
                return this.controlDataRecord.id === 0
                    ? this.$t('apiSettings.addControlData')
                    : this.$t('apiSettings.editControlData');
            },
            // return all controldataRecords except the current record.
            filteredControlDataRecords() {
                return this.controlDataRecords.filter(
                    (o) => o.id != this.controlDataRecord.id
                );
            },
            availableGemCodes() {
                return this.kadastraleGemeenteCodes.filter((o) => !o.userEnabled);
            },

            selectedGemCodes() {
                return this.kadastraleGemeenteCodes.filter((o) => o.userEnabled);
            }
        },

        methods: {
            $_showDomainModal() {
                this.showModal = true;
            },

            $_hideModal() {
                this.showModal = false;
            },

            $_rowClass() {
                return 'tablerow';
            },
            $_getKadastraleGemeenteCodes() {
                const gemCodes =
                    this.localControlDataRecord.kadastraleGemeenteCodes?.split(',');

                this.kadastraleGemeenteCodes = KADASTRALEGEMEENTECODES.map(
                    (item) => {
                        return {
                            id: item.Code,
                            text: `${item.Toelichting} (${item.Waarde})`,
                            userEnabled:
                                gemCodes?.includes(item.Code.toString()) ?? false
                        };
                    }
                );
            },
            $_updateKadastraleGemeenteCodes(event) {
                this.kadastraleGemeenteCodes = event;
            },
            $_onSubmit() {
                this.$_validateGemeenteNaam();
                this.$_validateSenderOrganizationName();
                this.$_validateSenderApplicationName();
                this.$_validateReceiverApplicationName();

                if (
                    this.receiverApplicationNameState &&
                    this.senderApplicationNameState &&
                    this.senderOrganizationNameState &&
                    this.gemeenteNaamState
                ) {
                    this.$_onSave();
                } else {
                    const data = {
                        message: this.$t('incorrectInputFields'),
                        variant: 'danger',
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
            },
            $_onSave() {
                this.localControlDataRecord.kadastraleGemeenteCodes =
                    this.selectedGemCodes.map((item) => item.id).join(',');

                this.$emit('save', this.localControlDataRecord);
                this.$_hideModal();
            },

            $_validateGemeenteNaam() {
                this.gemeenteNaamState = true;
                this.gemeenteNaamInvalidMessage = null;
                if (this.localControlDataRecord.gemeenteNaam) {
                    const inUse = this.filteredControlDataRecords.some(
                        (r) =>
                            r.gemeenteNaam ===
                            this.localControlDataRecord.gemeenteNaam
                    );
                    if (inUse) {
                        this.gemeenteNaamState = false;
                        this.gemeenteNaamInvalidMessage = this.$t(
                            'apiSettings.nameIsInUse'
                        );
                    }
                } else {
                    this.gemeenteNaamState = false;
                    this.gemeenteNaamInvalidMessage = this.$t('requiredField');
                }
            },
            $_validateReceiverApplicationName() {
                if (this.localControlDataRecord.receiverApplicationName) {
                    this.receiverApplicationNameState = true;
                    this.receiverApplicationNameInvalidMessage = null;
                } else {
                    this.receiverApplicationNameState = false;
                    this.receiverApplicationNameInvalidMessage =
                        this.$t('requiredField');
                }
            },
            $_validateSenderApplicationName() {
                if (this.localControlDataRecord.senderApplicationName) {
                    this.senderApplicationNameState = true;
                    this.senderApplicationNameInvalidMessage = null;
                } else {
                    this.senderApplicationNameState = false;
                    this.senderApplicationNameInvalidMessage =
                        this.$t('requiredField');
                }
            },
            $_validateSenderOrganizationName() {
                if (this.localControlDataRecord.senderOrganizationName) {
                    this.senderOrganizationNameState = true;
                    this.senderOrganizationNameInvalidMessage = null;
                } else {
                    this.senderOrganizationNameState = false;
                    this.senderOrganizationNameInvalidMessage =
                        this.$t('requiredField');
                }
            }
        },
        watch: {
            launchModal() {
                this.$_showDomainModal();
            },
            controlDataRecord(newValue) {
                this.localControlDataRecord = { ...newValue };
                this.$_getKadastraleGemeenteCodes();
            }
        }
    };
</script>

